module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-30"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carousel-slider",
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('li', {
      class: _vm.active(project),
      attrs: {
        "data-target": "#carousel-slider",
        "data-slide-to": index
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('slide', {
      key: project.id,
      attrs: {
        "project": project,
        "active": _vm.active(project)
      }
    })
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a834568"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Slider/Index.vue
// module id = 783
// module chunks = 1